import React, { useState } from 'react';
import { Button, Input, Typography, Box, Link } from '@mui/joy';
import { useNavigate, Link as RouterLink } from 'react-router-dom';
import axios from 'axios';

export default function SignIn() {
  const [formData, setFormData] = useState({ email: '', password: '' });
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // ✅ Use CRA environment variable
  const API_URL = process.env.REACT_APP_API_URL;

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setLoading(true);
    localStorage.clear(); // Clear old data

    try {
      console.log("Posting to:", `${API_URL}/api/login`); // Debug log

      const response = await axios.post(`${API_URL}/api/login`, formData);

      localStorage.setItem('token', response.data.token);
      localStorage.setItem('id', response.data.id);
      localStorage.setItem('role', response.data.role);

      const profileResponse = await axios.get(
        `${API_URL}/api/profile/${response.data.id}`,
        { headers: { Authorization: `Bearer ${response.data.token}` } }
      );

      localStorage.setItem('name', profileResponse.data.name || '');
      localStorage.setItem('verificationStatus', profileResponse.data.verificationStatus || '');
      localStorage.setItem('image', profileResponse.data.image || '');

      setMessage('Signed in successfully');

      // ✅ Fix role-based navigation
      if (response.data.role === 'admin') {
        navigate('/admin');
      } else if (response.data.role === 'worker') {
        navigate('/worker');
      } else {
        navigate('/worker-panel');
      }

    } catch (err) {
      setMessage(err.response?.data.message || 'Error signing in');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 420,
        mx: 'auto',
        p: 4,
        mt: 10,
        borderRadius: 2,
        boxShadow: 'lg',
        backgroundColor: '#fff',
      }}
    >
      <Typography
        level="h2"
        sx={{ mb: 3, textAlign: 'center', fontWeight: 'bold', color: 'primary.plainColor' }}
      >
        Sign In to Mosaic Global Tech
      </Typography>

      <form onSubmit={handleSubmit}>
        <Input
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          size="lg"
          variant="outlined"
          sx={{ mb: 2 }}
        />
        <Input
          name="password"
          placeholder="Password"
          type="password"
          value={formData.password}
          onChange={handleChange}
          size="lg"
          variant="outlined"
          sx={{ mb: 2 }}
        />
        <Button
          type="submit"
          fullWidth
          color="primary"
          variant="solid"
          loading={loading}
          disabled={loading}
          sx={{ mb: 2 }}
        >
          Sign In
        </Button>
      </form>

      {message && (
        <Typography
          color={message.includes('Error') ? 'danger' : 'success'}
          sx={{ mt: 2, textAlign: 'center' }}
        >
          {message}
        </Typography>
      )}

      <Typography sx={{ textAlign: 'center', mt: 2 }}>
        Don’t have an account?{' '}
        <Link component={RouterLink} to="/register" color="primary">
          Register
        </Link>
      </Typography>
    </Box>
  );
}